import classNames from 'classnames';
import { useEffect, useState, CSSProperties, ReactElement } from 'react';
import { previewPicture } from '@/utils';
import './index.scss';

interface IProps {
    className?: string;
    url: string;
    children?: ReactElement;
    allowPreview?: boolean;
}

const CoverImage = ({ url, children, className, allowPreview }: IProps) => {
    const [imgStyle, setImgStyle] = useState<CSSProperties>();

    const handlePreview = () => {
        if (!allowPreview) return;
        previewPicture(url);
    };

    useEffect(() => {
        const img = new Image();
        img.onload = () => {
            img.width > img.height ? setImgStyle({ width: 'auto', height: '100%' }) : setImgStyle({ width: '100%', height: 'auto' });
        };
        img.src = url;
    }, []);

    return (
        <div className={classNames('cover-image-container', className)}>
            {children}
            {imgStyle && <img src={url} style={imgStyle} alt="" onClick={handlePreview} />}
        </div>
    );
};

export default CoverImage;
